module.exports = __webpack_public_path__ + "img/星座內文標題裝飾.3a7cbd83.svg";